import React from "react";
import SideNavBar from "../../Components/SideBar/Sidebar";
import Navbar from "../../Components/Support/Header";
import { Redirect } from "react-router-dom";
import Cookies from "js-cookie";
import { Layout } from "antd";
// import "../UpdateCredentialsGrid/updateCredentialsGrid.css";
import "../../GlobalCss/SPF/updateCredentialsGrid.css";
import GridCredentialUpdate from "../../Components/GridCredentialUpdate/GridCredentialUpdate";
import ClientNavbar from "../../Components/ClientsNavbar/ClientNavbar";
const { Header, Content } = Layout;

const updatecredentialGrid = () => {
  const jwtToken = Cookies.get("jwt_token");
  //const userLogin = Cookies.get("UserLogin");
  const userRole = Cookies.get("Role");

  if (jwtToken === undefined) {
    return <Redirect to="/" />;
  }
  if (userRole === "Client User") {
    return (
      <Layout style={{ backgroundColor: "white", overflow: "hidden" }}>
      <Layout style={{ backgroundColor: "white" }}>
        <Header className="timecards-header">
          <ClientNavbar/>
        </Header>
        <Content>
          <div className="main-div">
            <div className="main-heading">Update Vms/Client Credentials</div>
            <h3>Note:Double click on the Rows to make them Editable and Press Enter to Save the Changes ,Double Click to Disable editing</h3>
            <GridCredentialUpdate />
          </div>
        </Content>
      </Layout>
    </Layout>

    );
  }

  return (
    <>
      <Layout style={{ backgroundColor: "white", overflow: "hidden" }}>
        <SideNavBar />
        <Layout style={{ backgroundColor: "white" }}>
          <Header className="timecards-header">
            <Navbar />
          </Header>
          <Content>
            <div className="main-div">
              <div style={{display:"flex",flexDirection:"column",alignItems:"flex-start",marginLeft:"50px"}}>
              <div className="main-heading">Update Vms/Client Credentials</div>
             
              </div>
              
              <GridCredentialUpdate />
            </div>
          </Content>
        </Layout>
      </Layout>
    
    </>
  );
};
export default updatecredentialGrid;
